
export const NEW_PRAGA_DOENCA = 'NEW_PRAGA_DOENCA'
export const NEW_PRAGA_DOENCA_SUCCESS = 'NEW_PRAGA_DOENCA_SUCCESS'

export const CANCEL_PRAGA_DOENCA_RAPIDO = 'CANCEL_PRAGA_DOENCA_RAPIDO'
export const CANCEL_PRAGA_DOENCA_RAPIDO_SUCCESS = 'CANCEL_PRAGA_DOENCA_RAPIDO_SUCCESS'

export const CREATE_PRAGA_DOENCA = 'CREATE_PRAGA_DOENCA'
export const CREATE_PRAGA_DOENCA_PENDING = 'CREATE_PRAGA_DOENCA_PENDING'
export const CREATE_PRAGA_DOENCA_SUCCESS = 'CREATE_PRAGA_DOENCA_SUCCESS'
export const CREATE_PRAGA_DOENCA_FAILURE = 'CREATE_PRAGA_DOENCA_FAILURE'

export const TABLE_PRAGA_DOENCA = 'TABLE_PRAGA_DOENCA'
export const TABLE_PRAGA_DOENCA_PENDING = 'TABLE_PRAGA_DOENCA_PENDING'
export const TABLE_PRAGA_DOENCA_SUCCESS = 'TABLE_PRAGA_DOENCA_SUCCESS'
export const TABLE_PRAGA_DOENCA_FAILURE = 'TABLE_PRAGA_DOENCA_FAILURE'

export const LIST_PRAGA_DOENCA = 'LIST_PRAGA_DOENCA'
export const LIST_PRAGA_DOENCA_PENDING = 'LIST_PRAGA_DOENCA_PENDING'
export const LIST_PRAGA_DOENCA_SUCCESS = 'LIST_PRAGA_DOENCA_SUCCESS'
export const LIST_PRAGA_DOENCA_FAILURE = 'LIST_PRAGA_DOENCA_FAILURE'

export const FIND_PRAGA_DOENCA = 'FIND_PRAGA_DOENCA'
export const FIND_PRAGA_DOENCA_PENDING = 'FIND_PRAGA_DOENCA_PENDING'
export const FIND_PRAGA_DOENCA_SUCCESS = 'FIND_PRAGA_DOENCA_SUCCESS'
export const FIND_PRAGA_DOENCA_FAILURE = 'FIND_PRAGA_DOENCA_FAILURE'

export const DELETE_PRAGA_DOENCA = 'DELETE_PRAGA_DOENCA'
export const DELETE_PRAGA_DOENCA_PENDING = 'DELETE_PRAGA_DOENCA_PENDING'
export const DELETE_PRAGA_DOENCA_SUCCESS = 'DELETE_PRAGA_DOENCA_SUCCESS'
export const DELETE_PRAGA_DOENCA_FAILURE = 'DELETE_PRAGA_DOENCA_FAILURE'

export const NEW_FILTER_PRAGA_DOENCA = 'NEW_FILTER_PRAGA_DOENCA'
export const NEW_FILTER_PRAGA_DOENCA_PENDING = 'NEW_FILTER_PRAGA_DOENCA_PENDING'
export const NEW_FILTER_PRAGA_DOENCA_SUCCESS = 'NEW_FILTER_PRAGA_DOENCA_SUCCESS'
export const NEW_FILTER_PRAGA_DOENCA_FAILURE = 'NEW_FILTER_PRAGA_DOENCA_FAILURE'

export const NEW_FILTER_NEXT_PAGE_PRAGA_DOENCA = 'NEW_FILTER_NEXT_PAGE_PRAGA_DOENCA'
export const NEW_FILTER_NEXT_PAGE_PRAGA_DOENCA_PENDING = 'NEW_FILTER_NEXT_PAGE_PRAGA_DOENCA_PENDING'
export const NEW_FILTER_NEXT_PAGE_PRAGA_DOENCA_SUCCESS = 'NEW_FILTER_NEXT_PAGE_PRAGA_DOENCA_SUCCESS'
export const NEW_FILTER_NEXT_PAGE_PRAGA_DOENCA_FAILURE = 'NEW_FILTER_NEXT_PAGE_PRAGA_DOENCA_FAILURE'